import { forwardRef, Fragment } from "react";

const SelectOptionsInput = forwardRef(
  (
    {
      onChange,
      name,
      label,
      options,
      error,
      defaultValue,
      selectedValue,
      onOptionClick,
      setSelectedCountry,
      labelClass,
    },
    ref
  ) => (
    <Fragment>
      {label ? (
        <h6 htmlFor="exampleInputEmail1" className={`form-label ${labelClass}`}>
          {label}
        </h6>
      ) : null}
      {error}
      <select
        className={`form-select ${error ? "errorBorder" : ""}`}
        aria-label="Default select example"
        onChange={(e) => {
          onChange(e);
          onOptionClick && onOptionClick(e);
          if (name === "country" && label === "Location") {
            setSelectedCountry(e.target.value);
          }
        }}
        name={name}
        ref={ref}
        defaultValue={defaultValue}
        value={defaultValue}
      >
        {selectedValue ? (
          <option selected value={""}>{selectedValue}</option>
        ) : (
          <option selected></option>
        )}
        {options &&
          options.length &&
          options.map((item, index) => {
              return (
                <option value={name !== "city" ? item.isoCode : item.name || item.value} key={index}>
                  {item.name}
                 
                </option>
              );
             
          })}
      </select>
    </Fragment>
  )
);

export default SelectOptionsInput;
